export default __webpack_public_path__ + "static/media/cat-rMAX.jpg.4294ded9.txt";